import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAllAppletVariables } from '@redviking/argonaut-util/src/mes/appletUtil';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getSocketTypeForVarId } from '../socket-var-helpers';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const varWriteNodeSpec: NodeSpec<NodeCfg<'varWrite'>> = {
    requiredSockets: [ 'trigger' ],
    cfg: () => ({ controlValues: { varId: '' }, id: getUID(), kind: 'varWrite', disabled: false, width: 210 }),
    controls: nodeCfg => ({
        varId: defineControlOpts({
            cfg: {
                kind: 'selectVar',
                label: 'Variable',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.varId,
        }),
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        value: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'varValue', label: 'Value' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                value: nodeCfg.socketDefaults?.inputs?.value,
            }),
            socket: getSocketTypeForVarId(nodeCfg.controlValues.varId),
        },
    }),
    kindLabel: 'Variable Write',
    nodeCategory: 'variable',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: (node, appletDesignVersionConfig) => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.varId) {
            errors.varId = 'Variable is required';
        }
        const allAppletVariables = getAllAppletVariables(appletDesignVersionConfig);
        if (!allAppletVariables[node.controlValues.varId]) {
            errors.varId = 'Variable is not a valid variable';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
